let state = {
    isLogin: false || sessionStorage.getItem('userInfo') ? true : false,
    isUpdateUserTime:"",//更新用户时间
}

//修改state
const mutations = {
    changLogin(state, val) {
        state.isLogin = val
    },
    changUpdateUserTime(state, val) {
        state.isUpdateUserTime = val
    }
}

export default { state, mutations }